var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../auth";
export var EntityContext = React.createContext({
    loading: true,
    makeUpdateUser: function () { return Promise.resolve(); },
    refreshEntityData: function () { return Promise.resolve(); },
    preferredName: null,
    jobDescription: null,
});
export var EntityProvider = function (_a) {
    var children = _a.children, entityDatasource = _a.entityDatasource;
    var rockId = useContext(AuthContext).rockId;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(), entity = _c[0], setEntity = _c[1];
    var formatEntity = function (entity) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        var name = ((_a = entity === null || entity === void 0 ? void 0 : entity.rocker) === null || _a === void 0 ? void 0 : _a.name) || ((_b = entity === null || entity === void 0 ? void 0 : entity.talent) === null || _b === void 0 ? void 0 : _b.name) || ((_c = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _c === void 0 ? void 0 : _c.name);
        var email = ((_e = (_d = entity === null || entity === void 0 ? void 0 : entity.rocker) === null || _d === void 0 ? void 0 : _d.user) === null || _e === void 0 ? void 0 : _e.email) ||
            ((_g = (_f = entity === null || entity === void 0 ? void 0 : entity.talent) === null || _f === void 0 ? void 0 : _f.user) === null || _g === void 0 ? void 0 : _g.email) ||
            ((_j = (_h = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _h === void 0 ? void 0 : _h.user) === null || _j === void 0 ? void 0 : _j.email);
        var is2faEnabled = ((_l = (_k = entity === null || entity === void 0 ? void 0 : entity.rocker) === null || _k === void 0 ? void 0 : _k.user) === null || _l === void 0 ? void 0 : _l.is2faEnabled) ||
            ((_o = (_m = entity === null || entity === void 0 ? void 0 : entity.talent) === null || _m === void 0 ? void 0 : _m.user) === null || _o === void 0 ? void 0 : _o.is2faEnabled) ||
            ((_q = (_p = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _p === void 0 ? void 0 : _p.user) === null || _q === void 0 ? void 0 : _q.is2faEnabled);
        var documentType = ((_r = entity === null || entity === void 0 ? void 0 : entity.rocker) === null || _r === void 0 ? void 0 : _r.documentType) ||
            ((_s = entity === null || entity === void 0 ? void 0 : entity.talent) === null || _s === void 0 ? void 0 : _s.documentType) ||
            ((_t = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _t === void 0 ? void 0 : _t.documentType);
        var country = ((_u = entity === null || entity === void 0 ? void 0 : entity.rocker) === null || _u === void 0 ? void 0 : _u.location) ||
            ((_v = entity === null || entity === void 0 ? void 0 : entity.talent) === null || _v === void 0 ? void 0 : _v.location) ||
            ((_w = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _w === void 0 ? void 0 : _w.location);
        var document = ((_x = entity === null || entity === void 0 ? void 0 : entity.rocker) === null || _x === void 0 ? void 0 : _x.document) ||
            ((_y = entity === null || entity === void 0 ? void 0 : entity.talent) === null || _y === void 0 ? void 0 : _y.document) ||
            ((_z = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _z === void 0 ? void 0 : _z.document);
        var preferredName = ((_0 = entity === null || entity === void 0 ? void 0 : entity.rocker) === null || _0 === void 0 ? void 0 : _0.preferredName) ||
            ((_1 = entity === null || entity === void 0 ? void 0 : entity.talent) === null || _1 === void 0 ? void 0 : _1.preferredName) ||
            ((_2 = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _2 === void 0 ? void 0 : _2.preferredName);
        var jobDescription = (_3 = entity === null || entity === void 0 ? void 0 : entity.employee) === null || _3 === void 0 ? void 0 : _3.jobDescription;
        return {
            name: name,
            email: email,
            documentType: documentType,
            country: country,
            document: document,
            is2faEnabled: is2faEnabled,
            preferredName: preferredName,
            jobDescription: jobDescription,
        };
    };
    var requestEntityData = function () {
        setLoading(true);
        entityDatasource
            .getByRockId(rockId)
            .then(function (data) {
            setEntity(formatEntity(data));
        })
            .finally(function () { return setLoading(false); });
    };
    var makeUpdateUser = useCallback(function (entity) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, entityDatasource.updateEntity(rockId, entity)];
                case 1:
                    _a.sent();
                    requestEntityData();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        if (!rockId)
            return;
        requestEntityData();
    }, [rockId]);
    return (React.createElement(EntityContext.Provider, { value: __assign(__assign({ loading: loading }, (entity || {})), { makeUpdateUser: makeUpdateUser, refreshEntityData: requestEntityData }) }, children));
};
